import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type Location = {
  locationid: string;
  locationcode: string;
  locationdesc: string;
};

export type CountryCode = {
  countrycode: string;
  englishname: string;
  dialcode: string;
};

const getLocations = async (
  searchQuery?: string,
  page?: number,
  limit?: number,
): Promise<{ locations: Location[]; totalPages: number }> => {
  const params = new URLSearchParams();
  if (searchQuery) params.set('q', searchQuery);
  if (limit !== undefined) params.set('limit', String(limit));
  if (page !== undefined) params.set('page', String(page));
  const response = await fetch(`/api/locations?${params}`);
  return response.json();
};

export const LOCATIONS_QUERY_KEY = 'locations';
export const COUNTRY_CODES_QUERY_KEY = 'country-codes';

export const useLocations = ({
  searchQuery,
  page,
  limit = 5,
}: {
  searchQuery?: string;
  page?: number;
  limit?: number;
}) =>
  useQuery({
    queryKey: [LOCATIONS_QUERY_KEY, searchQuery, page, limit],
    queryFn: () => getLocations(searchQuery, page, limit),
    placeholderData: keepPreviousData,
  });

const getCountryCodes = async (): Promise<CountryCode[]> => {
  try {
    const response = await fetch('/api/country-codes');

    if (!response.ok) {
      console.error('Failed to fetch country codes:', response.status, response.statusText);
      return [];
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching country codes:', error);
    return [];
  }
};

export const useCountryCodes = () =>
  useQuery({
    queryKey: [COUNTRY_CODES_QUERY_KEY],
    queryFn: () => getCountryCodes(),
    retry: 1,
  });
